import Fox from '../Fox'
import { useTheme } from '../../theme'

// En-tete de connexion : renard dans un orbe de verre (halo qui respire +
// flottement) + wordmark serif + baseline. Fidele a l'ecran de connexion du
// prototype v7.3 — wordmark « manrina », baseline « Lyannaj — ... » (le portail
// avait interverti les deux jusqu'en S31).
export default function ConnexionNav() {
  const { isWeb3 } = useTheme()
  const tc = 'text-ink'
  const ts = isWeb3 ? 'text-white/55' : 'text-ink/55'
  return (
    <div className="text-center mb-7">
      <div className="relative mx-auto mb-1.5" style={{ width: 96, height: 96 }}>
        <div className="absolute rounded-full" style={{ inset: -10, background: 'radial-gradient(circle, rgba(244,137,83,0.4), transparent 70%)', animation: 'haloPulse 4s ease-in-out infinite' }} />
        <div className={`absolute inset-0 flex items-center justify-center ${isWeb3 ? '' : 'glass'}`}
          style={{ borderRadius: '46% 54% 52% 48% / 50% 50% 50% 50%', animation: 'foxBob 5s ease-in-out infinite', background: isWeb3 ? 'rgba(255,255,255,0.06)' : undefined, border: isWeb3 ? '1px solid rgba(255,255,255,0.12)' : undefined }}>
          <Fox size={56} />
        </div>
      </div>
      <p className={`font-serif ${tc}`} style={{ fontSize: 30, lineHeight: 1.1 }}>manrina</p>
      <p className={`text-[12.5px] mt-0.5 ${ts}`}>Lyannaj — la production locale en direct</p>
    </div>
  )
}
